// extracted by mini-css-extract-plugin
module.exports = {"component":"styles_component__2b9UI"};